import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'blue' | 'orange' | 'green' | 'red' | 'gray';
  variant?: 'spinner' | 'dots' | 'pulse';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  color = 'blue',
  variant = 'spinner',
  className = ''
}) => {
  // Dimensiuni
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const dotSizes = {
    sm: 'w-1 h-1',
    md: 'w-1.5 h-1.5',
    lg: 'w-2 h-2'
  };

  // Culori
  const colors = {
    blue: 'border-blue-500',
    orange: 'border-orange-500',
    green: 'border-green-500',
    red: 'border-red-500',
    gray: 'border-gray-500'
  };

  const dotColors = {
    blue: 'bg-blue-500',
    orange: 'bg-orange-500',
    green: 'bg-green-500',
    red: 'bg-red-500',
    gray: 'bg-gray-500'
  };

  const renderVariant = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="flex space-x-1">
            {[0, 1, 2].map((i) => (
              <div
                key={i}
                className={`${dotSizes[size]} ${dotColors[color]} rounded-full animate-bounce`}
                style={{ animationDelay: `${i * 0.1}s` }}
              />
            ))}
          </div>
        );

      case 'pulse':
        return (
          <div className={`${sizes[size]} ${dotColors[color]} rounded-full animate-pulse`} />
        );

      case 'spinner':
      default:
        return (
          <div
            className={`
              ${sizes[size]}
              border-2
              ${colors[color]}
              border-t-transparent
              rounded-full
              animate-spin
            `}
            role="status"
            aria-label="Loading"
          >
            <span className="sr-only">Loading...</span>
          </div>
        );
    }
  };

  return (
    <div className={`inline-flex items-center justify-center ${className}`}>
      {renderVariant()}
    </div>
  );
};

export default LoadingSpinner;